import { appEnv, isProduction } from "../env";

export function EnvBanner() {
  if (isProduction) return null;
  const color = appEnv === "local" ? "bg-emerald-600" : "bg-amber-500";
  const label = appEnv === "local" ? "LOCAL · données mockées" : "RECETTE · données mockées";
  return (
    <div
      className={`${color} fixed bottom-3 left-3 z-50 rounded px-3 py-1 text-xs font-bold uppercase tracking-wider text-white shadow-lg`}
      role="status"
      aria-live="polite"
    >
      {label}
    </div>
  );
}
